<script>

import accountService from '@/services/account.service'
import Icon from "@/components/Icon/Icon.vue"
import Dialog from 'primevue/dialog'

export default {
  name: 'AccountDelegateListModal',
  components: {
      accountService,
      Icon,
      Dialog,
  },
  data() {
      return {
        uuid: '',
        nom: '',
        delegates: [],
        showModal: false,
        traited: false,
      }
  },
  props: {
    externUuidModal: {
        type: String
    },
    externNameModal: {
        type: String
    },
    externShowDelegateListModal: {
        type: Boolean
    },
  },
  watch: {
    externUuidModal: function(newVal) {
        this.uuid = newVal
    },
    externNameModal: function(newVal) {
        this.nom = newVal
    },
    externShowDelegateListModal: function(newVal) {
        this.showModal = newVal

        if(this.showModal == true) {
          accountService.getDelegate(this.uuid)
          .then(data => {
            this.delegates = data
          })
        }
    },
  },
  methods: {
      beforeClose () {
          this.showModal = false
          this.$emit('close', {
            traited: this.traited,
            name: this.nom,
          });
          this.traited = false
          this.uuid = ''
          this.nom = ''
          this.delegates = []
      },
      close() {
        this.showModal = false
      },
      removeUser(uuid) {
        accountService.removeDelegate(this.uuid, uuid)
        .then(() => {
          this.delegates = this.delegates.filter((obj) => {
            return obj.user.uuid !== uuid
          });
        })
      },
      isRights($rights) {
        console.log($rights)
        if($rights == 'TTTT') {
          return true
        }

        return false
      },
      changeWrite($event, uuid) {
        let data = {rights: 'FFFF'}
        if($event.target.checked == true) {
          data = {rights: 'TTTT'}
        }

        accountService.modifyDelegate(this.uuid, uuid, data)
      }
  },
}

</script>

<template>
  <Dialog
        v-model:visible="showModal"
        modal
        class="flex justify-center items-center"
        :showHeader="false"
        :dismissableMask="true"
        :baseZIndex="1500"
        contentClass="relative p-0 rounded-lg bg-white dark:bg-gray-900"
        @hide="beforeClose"
    >
      <header class="bg-orange-300 p-2">
        <div class="text-right">
          <div @click="close()" class="cursor-pointer">Fermer</div>
        </div>
      </header>
      <div class="m-0 px-16 py-10 relative bg-white dark:bg-gray-900 border border-orange-300">
        <div class="">{{ nom }}</div>
        <div class="mt-4">
          <div v-if="delegates.length">
            <table>
              <thead class="border-b font-medium dark:border-neutral-500">
                <tr>
                  <th scope="col" class="px-6 py-4" @click="sort()">Nom</th>
                  <th scope="col" class="px-6 py-4">Prénom</th>
                  <th scope="col" class="px-6 py-4">Écriture</th>
                  <th scope="col" class="px-6 py-4">Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  :ref="delegate.user.uuid"
                  class="border-b dark:border-neutral-500"
                  :v-model="delegates"
                  v-for="delegate in delegates"
                  :key="delegate.user.uuid"
                >
                  <td class="whitespace-nowrap px-6 py-0">{{ delegate.user.first_name }}</td>
                  <td class="whitespace-nowrap px-6 py-0">{{ delegate.user.last_name }}</td>
                  <td class="whitespace-nowrap px-6 py-0 text-center">
                    <div class="flex-row justify-center">
                      <input @change="changeWrite($event, delegate.user.uuid)" class="m-auto" name="write" type="checkbox" :checked="isRights(delegate.accountuser.rights)" />
                    </div>
                  </td>
                  <td class="whitespace-nowrap px-6 py-0 text-center">
                    <div
                      v-if="delegate.user.uuid != $store.state.profil.user"
                      :uuidDelegate="delegate.user.uuid"
                      @click="removeUser(delegate.user.uuid)"
                      class="hover:cursor-pointer">
                      <icon name="trash-o" :size="16" color="black" class="w-6 h-6" />
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div v-else>
            Aucun délégué
          </div>
        </div>
      </div>
  </Dialog>
</template>

<style scoped>

.btn {
@apply bg-orange-300 hover:bg-orange-600 p-2 rounded
}

</style>
